import { Container, Row, Col } from 'react-bootstrap';
import officeImg from '../assets/craftmanship.jpg'
import { useTranslation } from 'react-i18next';

const Craftsmanship = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5" style={{ backgroundColor: 'var(--color-surface)' }}>
      <Container className="py-5">
        <Row className="align-items-center flex-lg-row-reverse g-4">
          <Col lg={6} data-aos="fade-left">
            <div className="hero-img-container shadow">
              <img 
                src={officeImg} 
                alt="Expertise and Craftsmanship" 
                className="img-fluid w-100"
                style={{ 
                  borderRadius: '16px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </Col>
          <Col lg={6} className="text-center text-lg-start ps-lg-5" data-aos="fade-right" data-aos-delay="200">
            <h6 className="text-uppercase mb-3" style={{ color: 'var(--color-accent)', letterSpacing: '2px', fontWeight: 'bold' }}>
              {t('craftsmanship.subtitle')}
            </h6>
            <h2 className="display-5 fw-bold text-dark mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
              {t('craftsmanship.title')}
            </h2>
            <div style={{ width: '60px', height: '3px', backgroundColor: 'var(--color-accent)' }} className="mb-4"></div>
            <p className="lead text-dark opacity-75 mb-4" style={{ lineHeight: '1.8' }}>
              {t('craftsmanship.p1')}
            </p>
            <p className="text-dark opacity-50" style={{ lineHeight: '1.8' }}>
              {t('craftsmanship.p2')}
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Craftsmanship;
